// extracted by mini-css-extract-plugin
export default {"container":"vA-z"};